import Page from ".";
import ManagePage from "../../../../components/sections/admin/Page/ManagePage";

export const pageRoutes = (data) => [
  {
    path: "/admin/page",
    title: "Page",
    layout: "admin",
    routeType: "admin",
    component: Page,
  },
  {
    path: `/admin/manage-page/:id`,
    component: ManagePage,
    layout: "admin",
    routeType: "admin",
    title: "Manage Page",
  },
];
